import React, { PropsWithChildren } from 'react'

import Section from 'components/Section'

import icon1 from './images/icon1.png'
import icon2 from './images/icon2.png'
import icon3 from './images/icon3.png'
import icon4 from './images/icon4.png'

import styles from './style.less'

interface CardProps {
  icon: string
}

function Card({ icon, children }: PropsWithChildren<CardProps>) {
  return (
    <li className={styles.card}>
      <div className={styles.iconWrap}>
        <img src={icon} className={styles.icon} />
      </div>
      <div className={styles.text}>{children}</div>
    </li>
  )
}

export default function BillingType() {
  return (
    <Section title="计费方式" name="billingType" grey={false} withTailPadding className={styles.wrap}>
      <ul className={styles.container}>
        <Card icon={icon1}>费用月结</Card>
        <Card icon={icon2}>实时流量查看收益</Card>
        <Card icon={icon3}>错峰售卖</Card>
        <Card icon={icon4}>计费方式灵活</Card>
      </ul>
    </Section>
  )
}
